<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.3394 13.2954C26.3394 12.3736 26.2566 11.4873 26.103
       10.6364H13.8594V15.665H20.8557C20.5544 17.29 19.6385 18.6668 18.2616
        19.5886V22.8504H22.463C24.9212 20.5873 26.3394 17.2545 26.3394 13.2954Z"
      fill="#4285F4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8595 26C17.3695 26 20.3122 24.8359 22.4631 22.8504L18.2617
       19.5886C17.0976 20.3686 15.6085 20.8295 13.8595 20.8295C10.4735 20.8295
        7.60764 18.5427 6.58537 15.47H2.24219V18.8382C4.38128 23.0868 8.77764 26
         13.8595 26Z"
      fill="#34A853"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.58528 15.47C6.32528 14.69 6.17756 13.8568 6.17756 13C6.17756 12.1432
       6.32528 11.31 6.58528 10.53V7.1618H2.2421C1.36165 8.9168 0.859375 10.9023
        0.859375 13C0.859375 15.0977 1.36165 17.0832 2.2421 18.8382L6.58528 15.47Z"
      fill="#FBBC05"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8595 5.17045C15.7681 5.17045 17.4817 5.82636 18.829 7.11454L22.5576
       3.38591C20.3063 1.28818 17.3635 0 13.8595 0C8.77764 0 4.38128 2.91318 2.24219
        7.16182L6.58537 10.53C7.60764 7.45727 10.4735 5.17045 13.8595 5.17045Z"
      fill="#EA4335"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  data() {
    return {
      isHover: false,
    };
  },
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
      default: '14',
    },
    width: {
      type: String,
      default: '14',
    },
  },
};
</script>
